import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "../context/LangContext";
import { translations } from "./translation";
import { useTheme } from "../context/ThemeContext";

export default function About() {
  const { scrollY } = useScroll();
  const { lang } = useLang();
  const t = translations;
  const { theme, mode } = useTheme();

  const y = useTransform(scrollY, [0, 600], [0, 100]);
  const opacity = useTransform(scrollY, [0, 300], [0.6, 1]);

  return (
    <section
      id="about"
      style={{
        padding: "140px 20px",
        background: theme.bg,
        color: theme.text,
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* ✨ ПАРАЛЛАКС */}
      <motion.div
        style={{
          position: "absolute",
          inset: 0,
          y,
          opacity,
          background:
            mode === "dark"
              ? "radial-gradient(circle at center, rgba(25,118,210,0.15), transparent 70%)"
              : "radial-gradient(circle at center, rgba(25,118,210,0.08), transparent 75%)",
        }}
      />

      <div
        style={{
          maxWidth: "900px",
          margin: "0 auto",
          position: "relative",
          zIndex: 2,
        }}
      >
        {/* 🔥 TITLE */}
        <motion.h2
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          style={{
            fontSize: "clamp(32px, 5vw, 56px)",
            fontWeight: 700,
            marginBottom: "30px",
            lineHeight: 1.2,
            color: theme.secondaryText,
          }}
        >
          {t.aboutTitle[lang]}
        </motion.h2>

        {/* ✨ SUBTITLE */}
        <motion.p
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          style={{
            fontSize: "clamp(18px, 2.5vw, 22px)",
            color: theme.secondaryText, // ✅ было #aaa
            marginBottom: "40px",
          }}
        >
          {t.aboutSubtitle[lang]}
        </motion.p>

        {/* 🧠 TEXT */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          variants={{
            hidden: {},
            visible: {
              transition: {
                staggerChildren: 0.2,
              },
            },
          }}
        >
          {t.aboutTexts[lang].map((text, i) => (
            <motion.p
              key={i}
              variants={{
                hidden: { opacity: 0, y: 30 },
                visible: { opacity: 1, y: 0 },
              }}
              style={{
                fontSize: "clamp(15px, 2vw, 18px)",
                lineHeight: 1.8,
                color: theme.secondaryText, // ✅ было #ccc
                marginBottom: "20px",
              }}
            >
              {text}
            </motion.p>
          ))}
        </motion.div>

        {/* ✨ ЛИНИЯ */}
        <motion.div
          initial={{ width: 0 }}
          whileInView={{ width: "100px" }}
          transition={{ delay: 0.6 }}
          style={{
            height: "4px",
            background: theme.accent, // ✅ теперь из темы
            marginTop: "40px",
            borderRadius: "10px",
          }}
        />
      </div>
    </section>
  );
}
